const _ = require('lodash');
const CorporateLogin = require('swa-corporate-login/corporate-login.corporate');
const LandingPageAirReservationSearchForm = require('swa-landing-page/landing-air-reservation-search-form');
const LandingPageChangeLogin = require('./corporate-landing-home-page-change-login');
const LandingPageFlightStatusSearchForm = require('swa-landing-page/landing-flight-status-search-form');
const TabNavigationColdData = require('swa-bootstrap-data/corporate/corporate-landing-page-tab-navigation-cold-data');

const defaultNavigationData = {
    login: {
        buttonSize: 'huge',
        icon: 'passenger',
        name: 'login',
        panel: CorporateLogin,
        title: 'TEXT__LOGIN_TITLE'
    },
    checkIn: {
        buttonSize: 'huge',
        icon: 'check-in',
        name: 'check-in',
        panel: LandingPageAirReservationSearchForm,
        title: 'TEXT__CHECK_IN_TITLE'
    },
    flightStatus: {
        buttonSize: 'huge',
        icon: 'clock',
        name: 'flight-status',
        panel: LandingPageFlightStatusSearchForm,
        title: 'TEXT__FLIGHT_STATUS_TITLE'
    },
    change: {
        buttonSize: 'huge',
        icon: 'change-flight',
        name: 'change/cancel',
        panel: LandingPageChangeLogin,
        title: 'TEXT__CHANGE_CANCEL_TITLE'
    }
};

module.exports = _.merge(defaultNavigationData, TabNavigationColdData);
